<span class="radio-wrapper">
  <label class="container" (click)="onClick($event)">
    <input
      type="radio"
      value="true"
      name="{{ name }}-radio"
      [checked]="value === true" />
    <span class="radio"></span>
    Yes
  </label>
  <label class="container" (click)="onClick($event)">
    <input
      type="radio"
      value="false"
      name="{{ name }}-radio"
      [checked]="value === false" />
    <span class="radio"></span>
    No
  </label>
  <input type="hidden" name="{{ name }}" value="value" />
</span>
